// extracted by mini-css-extract-plugin
export default {"your_rd":"IA","title":"JA","subtitle":"KA","rd_bio_wrapper":"LA","rd_text_mobile":"MA","rd_bio":"NA","img":"OA","rd_info":"PA","rd_name":"QA","rd_stat":"RA","rd_text":"SA","btn_mobile":"TA"};
    if(module.hot) {
      // 1738064241496
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  